import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import Box from 'fe-design-base/atoms/Box';
import Text from 'fe-design-base/atoms/Text';
import PropTypes from 'prop-types';

import { toI18n } from 'util/i18n';

const Note = ({
  note,
  className,
  eventType,
  noteBody,
  date,
  rating,
  body,
  employeeName,
  title,
}) => {
  function formattedName() {
    if (rating || body) {
      return employeeName;
    }
    let name = note.get('first_name');
    const lname = note.get('last_name');
    if (lname) {
      name += ` ${lname[0]}.`;
    }
    return name;
  }

  const eventTypeProp = toI18n(
    `timecard_modal_v3.timesheet_note_event.${eventType}`
  );

  function noteTitle() {
    return (
      `timecard_modal_v3.note_section.${
        note.get('no_show') ? 'no_show_' : ''
      }` +
      'note_from' +
      `${eventType ? '_about' : ''}`
    );
  }

  return (
    <Box pv={4} className={className} data-testid={className}>
      <Box column p={16} bcolor="mono400" bw={1} bradiuss>
        <Box>
          {title ? (
            <Text variant="bodyBold" color="mono900">
              {title}
            </Text>
          ) : (
            <Text
              variant="bodyBold"
              color="mono900"
              i18n={noteTitle()}
              i18nProps={{ name: formattedName(), event_type: eventTypeProp }}
            />
          )}
        </Box>
        <Box>
          {rating && (
            <Box>
              <Text
                variant="body"
                color="mono900"
                i18n="timecard_modal_v3.note_section.rating"
                i18nProps={{ stars: rating }}
              />
            </Box>
          )}
          <Text variant="body" color="mono900">
            "{body || noteBody}"
          </Text>
        </Box>
        <Box pl={2} pt={4}>
          <Text variant="caption" color="mono700">
            {date && date.format('ddd, MMM D | h:mm a')}
          </Text>
        </Box>
      </Box>
    </Box>
  );
};

Note.propTypes = {
  note: ImmutablePropTypes.map,
  className: PropTypes.string.isRequired,
  noteBody: PropTypes.string,
  employeeName: PropTypes.string,
  eventType: PropTypes.string,
  rating: PropTypes.number,
  date: PropTypes.object,
};

export default Note;
